import { AssetAllocationDTO } from '../Profile/Accounts/api/useDefaultAssetAllocationQuery';

export enum ManualAccountsAssetAllocationStrategyIdDTO {
  Cash,
  Model,
  CMA,
  Inherit,
}

export enum ManualAccountsAssetAllocationTaxStatusIdDTO {
  TaxableInvestment = 'TaxableInvestment',
  TaxDeferred = 'TaxDeferred',
  TaxFree = 'TaxFree',
  Other = 'Other',
}

export type AssetAllocationModelDTO = { id: string };

export type ManualAccountsAssetAllocationDTO = {
  strategy: ManualAccountsAssetAllocationStrategyIdDTO;
  details: Record<
    ManualAccountsAssetAllocationTaxStatusIdDTO,
    AssetAllocationDTO[] | AssetAllocationModelDTO
  > | null;
};

export const MANUAL_ACCOUNTS_ASSET_ALLOCATION_TAX_STATUSES = Object.values(
  ManualAccountsAssetAllocationTaxStatusIdDTO,
).filter(v => typeof v === 'string');
